module.exports = "<div class=\"kids-image\">\n  <img [src]=\"getSrc(src)\"  (error)=\"src = defaultSrc\" (click)=\"viewPic()\">\n</div>\n"